import {format as fnsFormat, format} from "date-fns"
import ptBR from "date-fns/locale/pt-BR"

type Formats = "dd/MM/yyyy" | "dd/MM/yyyy HH:mm:ss" | "MM/dd/yyyy" | "yyyy/MM/dd" | "yyyy/MM/dd HH:mm:ss" | "yyyy-MM-dd"

const dateFormat = (value: string | Date, format: Formats = "dd/MM/yyyy"): string => {
    if (!value) return '';
    try {
        if(typeof value === 'string') {
            return String(fnsFormat(new Date(value), format, {locale: ptBR}));
        } else {
            return String(fnsFormat(value, format, {locale: ptBR}));
        }
    } catch (e) {
        console.error('Ocorreu um erro ao formatar a data', e)
        return '';
    }
}

const stringToDate = (value: string): Date => {
    const splitDate = value.split("/");
    const formattedDate = `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
    const birthdate = new Date(formattedDate);

    return birthdate;
}

type ReturnType = "string" | "date";

const splitDateFormat = (value: string): string => {
    const splitDate = value.split('/');

    const formatedDate = `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`;

    return format(new Date(formatedDate), "yyyy-MM-dd");
}

export default dateFormat

export {
    stringToDate,
    splitDateFormat
}